/* First-touch attribution for every lead form on the site (Andrew, 2026-09-23:
   the Miro board's "Blog ← Google + ChatGPT" — we need to know which one sent
   the lead). On the first page a visitor lands on we remember the external
   site that sent them (document.referrer) and any utm_* on that URL for 30
   days; every form that posts to the lead endpoint then carries them as hidden
   fd_* fields. The CRM turns them into the google / ai source.
   ⛔ First touch wins: after one click inside the site the referrer is our own
   domain, which says nothing. Storage can be blocked — every access is
   guarded and the forms work exactly as before without it. */
(function () {
  var KEY = 'fd_attrib_v1', TTL = 30 * 864e5;
  var own = /(^|\.)(furnace|cooling)\.direct$|(^|\.)myshopify\.com$|(^|\.)shopify\.com$/i;
  function read() { try { var v = JSON.parse(localStorage.getItem(KEY) || 'null'); return v && Date.now() - v.at < TTL ? v : null; } catch (e) { return null; } }
  function write(v) { try { localStorage.setItem(KEY, JSON.stringify(v)); } catch (e) {} }
  var q = {}; try { new URLSearchParams(location.search).forEach(function (v, k) { if (/^utm_/.test(k)) q[k] = v.slice(0, 80); }); } catch (e) {}
  var ref = ''; try { var h = document.referrer ? new URL(document.referrer).hostname : ''; if (h && !own.test(h)) ref = document.referrer.slice(0, 200); } catch (e) {}
  var cur = read();
  /* A new external arrival (or a tagged link) replaces a stale or empty record;
     plain internal navigation never overwrites it. */
  if (!cur || ((ref || Object.keys(q).length) && !cur.ref && !cur.utm_source)) {
    cur = { at: Date.now(), ref: ref, landing: (location.origin + location.pathname).slice(0, 200) };
    for (var k in q) cur[k] = q[k];
    write(cur);
  }
  function stamp(form) {
    if (!form || !/action=lead/.test(form.getAttribute('action') || '')) return;
    var a = read() || cur; if (!a) return;
    var f = { fd_referrer: a.ref, fd_landing: a.landing, fd_utm_source: a.utm_source, fd_utm_medium: a.utm_medium,
      fd_utm_campaign: a.utm_campaign, fd_utm_content: a.utm_content, fd_utm_term: a.utm_term };
    for (var n in f) {
      if (!f[n]) continue;
      var el = form.querySelector('input[name="' + n + '"]');
      if (!el) { el = document.createElement('input'); el.type = 'hidden'; el.name = n; form.appendChild(el); }
      el.value = f[n];
    }
  }
  function all() { var fs = document.querySelectorAll('form'); for (var i = 0; i < fs.length; i++) stamp(fs[i]); }
  if (document.readyState === 'loading') document.addEventListener('DOMContentLoaded', all); else all();
  /* Capture phase: runs before the form's own submit handler builds FormData. */
  document.addEventListener('submit', function (e) { stamp(e.target); }, true);
})();
